import { Injectable } from "@angular/core";
import { ReferenceField } from "@common/references/reference-field";
import { Meter, RemoteDevice } from "./meters.interfaces";
import { DefaultService } from "@common/references/default.service";
import urlJoin from "url-join";
import { environment } from "@environments/environment";
import { MeterFormComponent } from '@modules/settings/meters/meter-form/meter-form.component';
import { flattenToNestedObject, jsonToFormData } from '@shared/utils/object.utils';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class MetersService extends DefaultService<Meter> {
  backendName = 'meters';
  formComponent = MeterFormComponent;
  formModalOptions = {size: "lg", scrollable: true};
  title = 'MENU.METERS';
  titleSingular = 'METER';

  fields: ReferenceField[] = [
    {fieldName: 'name', label: 'METER.NAME', iconClass: 'las la-tachometer-alt'},
    {fieldName: 'serialNumber', label: 'METER.SERIAL_NUMBER', iconClass: 'las la-tachometer-alt'},
    {fieldName: 'manufacturer', label: 'METER.MANUFACTURER', iconClass: 'las la-building'},
    {fieldName: 'model', label: 'METER_TYPE.MODEL', iconClass: 'las la-sd-card'},
    {
      fieldName: 'connectivityStatus',
      label: 'METER.STATUS',
      iconClass: 'las la-cube',
      viewType: 'onOffStatus',
    },
    {
      fieldName:'unitType',
      label:'APARTMENT.UNIT_TYPE',
      viewType:'unitType'
    },
    {fieldName: 'actions', label: 'READINGS.ACTIONS', iconClass: 'las la-cog'},
  ];
  hasActions = true;
  hasAdd = true;
  hasDelete = true;

  getUrl(): string {
    return urlJoin(environment.apiUrl, 'meters');
  }

  createToBuilding(form: any) {
    return this._http.post(urlJoin(this.getUrl(), 'create-to-building'), form);
  }
  updateToBuilding(form: any, meterId) {
    return this._http.put(urlJoin(this.getUrl(), 'update-to-building', String(meterId)), form);
  }
  meterSearchRemote(serialNumber: string): Observable<RemoteDevice> {
    return this._http.get<any>(urlJoin(this.getUrl(), 'search/remote'), { params: { serialNumber } })
      .pipe(map(({ data }) => flattenToNestedObject(data)))
  }
}
